import appConfig from "../config";
import { filterDefined } from "./array-manipulations";

/**
 * Returns true if the environment is not clearly a preprod or local or tempdev environment
 * Not 100% accurate especially for speciifc preprod urls
 */
export const isProductionEnvironment = (hostname: string) => {
  if (
    hostname.includes("localhost") ||
    hostname.includes("preprod") ||
    hostname.includes("tempdev") ||
    hostname.includes("qa") ||
    hostname.includes("dev")
  )
    return false;
  return true;
};

export const isLocal = (hostname: string) => {
  if (hostname.includes("localhost") || hostname.includes("localtest.me"))
    return true;
  return false;
};
/**
 * Used for Sentry. Mostly best guess.
 */

export const getEnvName = (
  hostname: string,
): "OVH-PROD" | "OVH-PREPROD" | "TEMPDEV" | "LOCAL" | "OVH-DEV" | "US-PROD" => {
  if (isLocal(hostname)) return "LOCAL";
  if (hostname.includes("temp-app.dev.evidenceb")) return "OVH-DEV";
  if (hostname.includes("tempdev.evidenceb")) return "TEMPDEV";
  if (hostname.includes("preprod") || hostname.includes("qa"))
    return "OVH-PREPROD";
  if (hostname.includes("us.adaptivmath.com")) return "US-PROD";
  return "OVH-PROD";
};

/**
 * Returns the host with the basepath
 */
export const getHost = () => {
  return [window.location.host, appConfig.basePath]
    .filter(filterDefined)
    .join("/");
};
